import type { ReactNode } from 'react';

export const symbol_picture_in_picture_large: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M255-320q-12.75 0-21.37-8.63Q225-337.25 225-350v-357q0-12.75 8.63-21.38Q242.25-737 255-737h435q12.75 0 21.38 8.62Q720-719.75 720-707v357q0 12.75-8.62 21.37Q702.75-320 690-320H255ZM110-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-220 110-220h710v-550q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v550q0 24-18 42t-42 18H110Z"
		/>
	</svg>
);
